import { Routes } from '@angular/router';

import {
  i18nRedirect,
  languagePrefixGuard,
  translateRouteResolver
} from '@gruposaltaedu/liv-i18n/router';
import { providePageTranslation } from '@gruposaltaedu/liv-i18n/translate';

export const routes: Routes = [
  {
    path: ':lang',
    canMatch: [languagePrefixGuard],
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./features/auth/auth.routes').then((m) => m.authRoutes),
        providers: [providePageTranslation('auth')],
        resolve: { translations: translateRouteResolver }
      },
      {
        path: 'oops',
        loadComponent: () => import('./pages').then((m) => m.ErrorComponent),
        providers: [providePageTranslation('error')],
        resolve: { translations: translateRouteResolver }
      },
      {
        path: '404',
        loadComponent: () => import('./pages').then((m) => m.ErrorComponent),
        providers: [providePageTranslation('error')],
        resolve: { translations: translateRouteResolver },
        data: { code: 'NOT_FOUND' }
      },
      {
        path: '**',
        redirectTo: '404'
      }
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: i18nRedirect
  }
];
